import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import './EventItem.css';
import { Navigate } from 'react-router-dom';

const EventItem = ({ image, altText, eventName, handleEventClick }) => {
  const navigate = useNavigate();
  const handleNavigate = (selectedStyle) => {
    console.log(selectedStyle)
    navigate('/products', { state: { selectedStyle } });
  };
  return (
    <a
      href="#"
      className="event-container"
      onClick={(e) => {
        e.preventDefault(); // Prevent default anchor behavior
        handleNavigate(eventName); // Pass eventName to handleEventClick
      }}
    >
      <img
        src={image}
        alt={altText}
        className={`event-image ${eventName
          .toLowerCase()
          .replace(/ & /g, '-')
          .replace(/\s+/g, '-')}`}
      />
      <span className="event-name">{eventName}</span>
    </a>
  );
};

const EventList = () => {
  const navigate = useNavigate(); // Get the navigation function

  // Define handleEventClick inside EventList
  // const handleEventClick = (eventName) => {
  //   navigate('/products', { state: { seletedStyle : eventName } }); // Pass eventName to products page via state
  const handleEventClick = (eventName) => {
    const stateToPass = { selectedStyle: eventName }; // Define the state to pass
    console.log(`State to be passed:`, stateToPass); // Log the state before navigating

    // Navigate to '/products' and pass state
    navigate('/products', { state: {stateToPass} });

    // Optional: Set a timeout for 3 minutes to log the state again (if needed)
    setTimeout(() => {
      console.log(`State passed after timeout:`, stateToPass);
    }, 180000); // 3 minutes
  };

  const events = [
    { image: 'images/collections/DSC03877.jpg', altText: 'Suits', eventName: 'PreWedding Photoshoot' },
    { image: 'images/collections/DSC04628.jpg', altText: 'Sherwani', eventName: 'Attending Wedding' },
    { image: 'images/collections/DSC03611.jpg', altText: 'Suits', eventName: 'Graduation/Farewell' },
    { image: 'images/collections/DSC04170.jpg', altText: 'Suits', eventName: 'Ethnic Day' },
    { image: 'images/collections/DSC04573.jpg', altText: 'Sherwani', eventName: 'Weddings' },
    { image: 'images/collections/DSC04229.jpg', altText: 'Suits', eventName: 'Office Event' },
  ];

  return (
    <div className="container-full">
      <div className="container_rent_occasion">
        {events.map((event, index) => (
          <EventItem
            key={index}
            image={event.image}
            altText={event.altText}
            eventName={event.eventName}
            handleEventClick={handleEventClick}
          />
        ))}
      </div>
    </div>
  );
};

export default EventList;
